import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
import { Container, Stack, Tab, Tabs, Typography } from '@mui/material';
import useGetDirectory from '../hooks/useGetDirectory';
import { ProductSort, ProductList, ProductFilterSidebar } from '../sections/@dashboard/products';
import DirectoryMap from '../sections/@dashboard/products/DirectoryMap';


// ----------------------------------------------------------------------

export default function ProductsPage() {
  const [openFilter, setOpenFilter] = useState(false);

  const handleOpenFilter = () => {
    setOpenFilter(true);
  };

  const handleCloseFilter = () => {
    setOpenFilter(false);
  };

  const directories = useGetDirectory()

  

  function groupContactsByFirstLetter(contacts) {
    const groupedContacts = {};
  
    contacts.forEach(contact => {
      const firstLetter = contact.name.charAt(0).toUpperCase(); // Get the first letter and convert to uppercase
  
      if (!groupedContacts[firstLetter]) {
        // If the letter is not a key in the groupedContacts object, create an empty array for it
        groupedContacts[firstLetter] = [];
      }
  
      // Push the contact to the corresponding letter group
      groupedContacts[firstLetter].push(contact);
    });
  
    return groupedContacts;
  }
  
  const groupedContacts = directories && groupContactsByFirstLetter(directories);
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
 
  console.log(groupedContacts);
  return (
    directories && <>
      <Helmet>
        <title> Directory </title>
      </Helmet>

      <Container>

        <Typography variant="h4" sx={{ mb: 5 }}>
        Directory
        </Typography>

        <Tabs value={value}  variant="scrollable" onChange={handleChange} sx={{mb:4}}>
  <Tab label="Directory" />
  <Tab label="Map" />
</Tabs>
        

        {value === 0 && directories && <ProductList products={groupedContacts} />}
       {value === 1 &&  directories && <DirectoryMap list={directories} />}
      </Container>
    </>
  );
}
